import React, { ReactElement } from 'react';

import TDropdownFooterProps from './types/TDropdownFooterProps';
import componentName from './name';
import Box from '../../components/Box/Box';
import InputError from '../InputError';

const DropdownFooter = ({ errorText }: TDropdownFooterProps): ReactElement => (
  <Box parent={componentName} name="footer" as="footer">
    <InputError errorText={errorText} />
  </Box>
);

export default DropdownFooter;
